import React from "react";
import { apiPost, getHostApi } from '../../store/apiWrapper';
import { connect } from 'react-redux';
import { hasPermission, isOnPath } from '../../store/apiWrapper';
import { isNullOrUndefined } from "../../store/storeFunctions";
import { OpenChart, OpenChartCug } from "./iTrade/openChart";
import { setElementStyleViaSelector, setElementStyle, addElementClass, addElementClassViaSelector, removeElementClass, removeElementClassViaSelector } from '../../store/almightyElementWrapper';
import { withLocalize, Translate } from "react-localize-redux";
import BandTable from "./iTrade/bandTable";
import classnames from 'classnames';
import CugTable from "./iTrade/cug";
import ExcelExportButton from "../common/excelExportButton";
import Gradient from "./iTrade/gradient";
import ITradeChart from "./iTrade/iTradeChart";
import ITradeChartLegend from "./iTrade/iTradeChartLegend";
import ITradeLineChart from "./iTrade/iTradeLineChart";
import ITradeLineChartLegend from "./iTrade/iTradeLineChartLegend";
import Summary from "./iTrade/summary";
import SanitizedLink from "../common/sanitizedLink";

import "./iTrade/iTrade.scss";

class ITrade extends React.Component {

    state = {
        acceptConsent: false
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ((this.props.dataHash !== nextProps.dataHash) || (this.state.acceptConsent !== nextState.acceptConsent));
    }

    render() {
        let isITradeContributor = hasPermission(null, 'iTRADEContributor');
        let isITradeUnlimited = hasPermission(null, 'iTRADEUnlimited');
        return (this.props.data === undefined || this.props.data === null ? "" : this.renderWithData(this.props.data, isITradeContributor, isITradeUnlimited));
    }

    renderWithData(data, isITradeContributor, isITradeUnlimited) {
        let isSupplierCug = (!isNullOrUndefined(data) && data.subjectCountry === 'CZ') ? hasPermission(null, 'SupplierClosedGroupCzDetail') : ((!isNullOrUndefined(data) && data.subjectCountry === 'SK') && hasPermission(null, 'SupplierClosedGroupSkDetail'));

        if (data.showOffer)
            return this.renderOffer(data.offerUrl);

        return (data.availability.isAvailable) ? this.renderITrade(data, isITradeContributor, isITradeUnlimited, isSupplierCug) : this.renderNotAvailable();
    }

    renderITrade(data, isITradeContributor, isITradeUnlimited, isSupplierCug) {
        //filter all bands expect the first one, and check if total of totals is greater than 0
        //if yes, display chart, else hide
        let displayBarChart = data.bands.map(x => x.total).reduce((a, b) => a + b, 0) > 0;
        if (!this.state.acceptConsent && !data.enableItradeSection)
            return (

                <div id="iTrade-consent" className="iTrade-consent-box">
                    <div className='columns'>
                        <div className='column'>
                            <span className='underlined-title-wrapper'>
                                <span className="underlined-title"><Translate id="Report.Itrade.FopConsent" />
                                </span>
                            </span>
                            <div style={{ textAlign: "center", paddingTop: "1.5em" }}>
                                <button type="button" onClick={() => this.hideSection()}
                                    className={classnames('bb-button gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Common.No.Upper" />
                                </button>
                                <button type="button" onClick={() => this.sendConsent()}
                                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Common.Yes.Upper" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )

        return (
            <>
                {isITradeContributor &&
                    <div className="itrade-data-updated"><Translate id="Report.Itrade.DataUpdated" />&nbsp;{data.extended.period}</div>}
                <div className="itrade-root">
                    <div className="columns is-desktop is-multiline is-centered">
                        <div className="column is-7">
                            <div className="itrade-summary-root" style={{ minHeight: "250px" }}>
                                <Summary data={data.summary} extended={data.extended} enhancements={data.cugEnhancement} isITradeContributor={isITradeContributor} isITradeUnlimited={isITradeUnlimited} isSupplierCug={isSupplierCug} ></Summary>
                            </div>
                        </div>
                        <div className="column is-5">
                            <div className="itrade-gradient-root">
                                <Gradient index={data.summary.index}
                                    avgIndex={data.availability.avgTradeIndex}
                                    index0={data.indexes.index0}
                                    index1={data.indexes.index1}
                                    index2={data.indexes.index2}
                                    min={data.indexes.min}
                                    max={data.indexes.max} />
                            </div>
                        </div>
                    </div>

                    {/* show this part only on global report - hide in short report*/}
                    {isOnPath({ prefix: "/report/global" }) &&
                        <>
                            <div className="w-100 cug-root">
                            {isITradeContributor && isITradeUnlimited && isSupplierCug &&
                                <React.Fragment>
                                    <OpenChart data={data.extended}
                                        xLabel={this.props.translate("Report.Itrade.DelayDays")}
                                        yLabel={this.props.translate("Report.ITrade.PercentageOfTotalOwing")}
                                        header={this.props.translate("Report.ITrade.OwingHeader")} />
                                    <br className='hide-on-desktop' />
                                </React.Fragment>
                            }
                            {this.cugHasData(data.cugEnhancement) && isITradeContributor && isITradeUnlimited && isSupplierCug &&
                                <React.Fragment>
                                    <OpenChartCug data={data.cugEnhancement.find(x => !x.isHistorical && !x.isContributor)}
                                        xLabel={this.props.translate("Report.Itrade.DelayDays")}
                                        yLabel={this.props.translate("Report.ITrade.PercentageOfTotalOwing")}
                                        header={this.props.translate("Report.Itrade.TotalOwingCug")} />
                                    <CugTable data={data.cugEnhancement} currency={data.summary.currency} isHistorical={false} />
                                    <CugTable data={data.cugEnhancement} currency={data.summary.currency} isHistorical={true} />
                                    <br className='hide-on-desktop' />
                                </React.Fragment>
                            }
                            </div>
                            {(
                                displayBarChart ||
                                (Array.isArray(data.bands) && data.bands.length > 0)
                            ) && <>
                                    <div className="transaction-analysis-root w-100">
                                        {displayBarChart &&
                                            <div className="itrade-chart">
                                                <ITradeChart data={data.bands}
                                                    yLabel={this.props.translate("Repor.Itrade.PercentageInvoicedVolume")}
                                                    header={this.props.translate("Report.Itrade.PaymentAnalysis")}
                                                    xLabel={this.props.translate("Report.Itrade.DelayDays")}
                                                >
                                                </ITradeChart>
                                                <ITradeChartLegend data={data.bands} currency={data.summary.currency} />
                                            </div>
                                        }
                                        {(Array.isArray(data.bands) && data.bands.length > 0) &&
                                            <div className="itrade-table">
                                                <BandTable bands={data.bands} currency={data.summary.currency} />
                                            </div>
                                        }
                                    </div>
                                </>}
                            {(Array.isArray(data.periods) && data.periods.length > 0) &&
                                <div className="transaction-analysis-root w-100" style={{ marginTop: '20px' }}>
                                    <div className="itrade-line-chart">
                                        <ITradeLineChart
                                            data={data.periods}
                                            header={this.props.translate("Report.Itrade.SectorPaymentTrend")} />
                                        <ITradeLineChartLegend
                                            iTrade={this.props.translate("Report.Itrade.SubjectIndex")}
                                            avgTrade={this.props.translate("Report.Itrade.SectorPaymentTrend")} />
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>

                <ExcelExportButton link="itrade-info" entityId={this.props.id} report={this.props.reportType} />
            </>
        )
    }
    renderNotAvailable() {
        const mail = "helpdesk@repi.cz";
        const web = this.props.user.authentication.profile.agentLanguage === 'sk-SK' ? 'https://www.cribis.sk/' : 'https://www.mcribis.cz/';

        return (
            <div className="itrade-not-available">
                <p><Translate id="Report.Itrade.NotAvailable" /> <Translate id="Report.Itrade.NotAvailable3" /></p>
                <br />
                <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom">
                    <h5 className="underlined-title rb-header">
                        <Translate id="Report.Itrade.NotAvailable2" />
                    </h5>
                </span>
                <p><Translate id="Report.Itrade.NotAvailable6" /></p>
                <br />
                <p>
                    <span>
                        <Translate id="Report.Itrade.NotAvailable4" />
                        <a
                            className={classnames('link-internal', { 'is-normal': localStorage.locales_url_format === 'normal' })}
                            href={web}
                            onClick={e => window.location = web}
                        >
                            <Translate id={"LeftPanel.iTrade"} />
                        </a>.&nbsp;
                        <Translate id="Report.Itrade.NotAvailable5" />
                        <a
                            className={classnames('link-internal', { 'is-normal': localStorage.locales_url_format === 'normal' })}
                            href={`mailto:${mail}`}
                        >
                            {mail}.
                        </a>
                    </span>
                </p>
            </div>
        )
    }
    renderOffer(url) {
        return (
            <div>
                <Translate id="Report.Common.Section.Nonactivated.Desc" />
                &nbsp;
                <SanitizedLink link={url} label={`${this.props.translate("Report.Common.More")}...`} />
            </div>
        );
    }
    cugHasData(data) {
        if (data.length === 0) { return false; }
        return data.map(x => x.openTotal).reduce((acc, cur) => acc + cur) > 0;
    }

    hideSection = () => {
        setElementStyle(this.props.sectionId, "pointer-events", "none");
        setElementStyleViaSelector(`#${this.props.sectionId} .report-section-body`, "height", "0px");
        removeElementClass(this.props.sectionId, "is-expanded");
        removeElementClassViaSelector(`#${this.props.sectionId} .report-section-body`, "entered");
        removeElementClassViaSelector(`#${this.props.sectionId} .report-section-body`, "enter-done");
        addElementClass(this.props.sectionId, "info-na");
        addElementClassViaSelector(`#${this.props.sectionId} .report-section-body`, "exited");
        addElementClassViaSelector(`#${this.props.sectionId} .report-section-body`, "exit-done");
    }

    sendConsent = () => {
        apiPost(`${getHostApi()}/api/report/${this.props.id}/itrade-consent`, null,
            {
                entityId: this.props.id
            },
            (data) => {
                if (data.data) {
                    this.setState({ acceptConsent: true });
                }
                else {
                    this.setState({ acceptConsent: false });
                }
            },
            _ => {
                this.setState({ acceptConsent: false });
            }
        );
    }
}

export default withLocalize(connect(
    state => { return { user: state.userContext } }
)(ITrade));
